import React from 'react';

export const ActiveOrderView = React.createContext({
  activeOrderView: {},
  setActiveOrderViewData: () => {}
});
